import { uniq } from 'ramda'
import { useCallback, useEffect, useState } from 'react'

interface PasteFilesProps {
  inputRef?: any
}

const usePasteFiles = ({
  inputRef
}: PasteFilesProps) => {
  const [pastedFiles, setPastedFiles] = useState([])
  const [pastedTextFromFiles, setPastedText] = useState(null)

  const clearFiles = () => {
    setPastedFiles([])
    setPastedText(null)
  }

  const pasteHandler = useCallback((pasteEvent) => {
    if(!pasteEvent.clipboardData || !pasteEvent.clipboardData.files) {return}
    const files = [...pasteEvent.clipboardData.files]

    files.length && setPastedFiles(uniq([...pastedFiles, ...files]))
    files.length && setPastedText(pasteEvent.clipboardData.getData('Text'))
  }, [pastedFiles])

  useEffect(() => {
    if(!inputRef) {return}

    inputRef.current.onpaste = pasteHandler
  }, [inputRef, pasteHandler])


  return { pastedTextFromFiles, pastedFiles, clearFiles }
}

export default usePasteFiles

